import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";

const HorizontalSidebar = () => {
  const [opendSubMenu, setOpendSubMenu] = useState([null, null]);
  const sidebarRef = useRef(null);
  const location = useLocation();

  const showMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[0] === title ? [null, null] : [title, null]
    );
  };

  const showSubMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[1] === title ? [prevState[0], null] : [prevState[0], title]
    );
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setOpendSubMenu([null, null]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isActiveMainMenu = (mainMenus) => {
    const currentPath = location.pathname || "";

    return (
      (mainMenus.link &&
        currentPath.split("/")[1] === mainMenus.link.split("/")[1]) ||
      mainMenus.submenuItems?.some(
        (subMenu) =>
          subMenu.link &&
          currentPath.split("/")[1] === subMenu.link.split("/")[1]
      )
    );
  };

  const isActiveSubMenu = (mainMenus) => {
    const currentPath = location.pathname || "";
    return (
      (mainMenus.link &&
        currentPath.split("/")[1] === mainMenus.link.split("/")[1]) ||
      mainMenus.submenuItems?.some(
        (subMenu) =>
          subMenu.link &&
          currentPath.split("/")[1] === subMenu.link.split("/")[1]
      )
    );
  };

  return (
    <div
      className="sidebar sidebar-horizontal"
      id="horizontal-menu"
      ref={sidebarRef}
    >
      <div className="sidebar-menu" id="sidebar-menu-3">
        <div className="main-menu">
          <ul className="nav">
            {SidebarData.map((mainTittle, mainIndex) => (
              <li className="submenu" key={mainIndex}>
                <a
                  className={`${
                    opendSubMenu[0] === mainTittle.label ||
                    isActiveMainMenu(mainTittle)
                      ? "active"
                      : ""
                  }`}
                  onClick={() => showMenu(mainTittle.label)}
                >
                  {mainTittle.label === "Components" ? (
                    <i className="feather icon-layers"></i>
                  ) : (
                    <i className={`ti ti-${mainTittle.icon} me-2`}></i>
                  )}
                  <span>{mainTittle.label}</span>
                  <span className="menu-arrow"></span>
                </a>
                <ul
                  className={`submenus-two ${
                    opendSubMenu[0] === mainTittle.label ? "d-block" : "d-none"
                  }`}
                >
                  {mainTittle.submenuItems.map((mainMenus, menuIndex) => (
                    <React.Fragment key={menuIndex}>
                      {!mainMenus.submenu && (
                        <li>
                          <NavLink
                            to={mainMenus.link}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <span>{mainMenus.label}</span>
                          </NavLink>
                        </li>
                      )}
                      {mainMenus.submenu && (
                        <li className="submenu">
                          <a
                            className={`${
                              isActiveSubMenu(mainMenus) ? "active" : ""
                            }`}
                            onClick={() => showSubMenu(mainMenus.label)}
                          >
                            <span>{mainMenus.label}</span>
                            <span className="menu-arrow"></span>
                          </a>
                          <ul
                            className={`submenus-two ${
                              opendSubMenu[1] === mainMenus.label
                                ? "d-block"
                                : "d-none"
                            }`}
                          >
                            {mainMenus.submenuItems.map(
                              (subDropMenus, subIndex) => (
                                <li key={subIndex}>
                                  <NavLink
                                    to={subDropMenus.link}
                                    className={({ isActive }) =>
                                      isActive ? "active" : ""
                                    }
                                  >
                                    {subDropMenus.label}
                                  </NavLink>
                                </li>
                              )
                            )}
                          </ul>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HorizontalSidebar;
